import { makeRequest } from '../../utils';
import styles from './footeremail.module.css';
import { useState } from 'react';

export default function FooterEmail() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const signup = async () => {
    if (!validateEmail(email)) {
      setSuccess(false);
      setMessage(`Please enter a valid email.`);
      return;
    }
    let data = await makeRequest(`newsletter?email=${email}`);
    if (data.ok) {
      setSuccess(true);
      setMessage(`Thanks! You've successfully signed up!`)
    } else {
      setSuccess(false);
      setMessage(`There was a problem signing you up.`)
    }
  };

  return (
    <div className={styles.footerEmail}>
      <div>Sign up for our mailing list to receive news of upcoming titles and events.</div>
      <input
        type="email"
        className={styles.emailInput}
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            signup();
          }
        }}
      />
      {message && <p className={success ? styles.successMessage : styles.errorMessage}>{message}</p>}
    </div>
  );
}